import { defineMessage } from 'react-intl';
import { makeAutoObservable, reaction, SDK } from 'sdk';

const CANNOT_SEND_FILES = defineMessage({
	id: 'chat.errors.cannotSendAttachments',
	defaultMessage: 'Не удалось отправить файл(-ы)',
});

export class AttachmentErrorsStore {
	constructor(sdk: SDK) {
		makeAutoObservable(this);
		reaction(
			() => sdk.attachmentsStore.uploadAttachmentsRequestStatus.isError,
			(status) => {
				if (status && sdk.locale.intl) {
					this.setError(sdk.locale.intl?.formatMessage(CANNOT_SEND_FILES));
				}
			}
		);
	}

	error?: string;

	setError(error: string): void {
		this.error = error;
	}

	clearError(): void {
		this.error = '';
	}
}
